import * as React from 'react';
import { cn } from '@/lib/utils';

const ActivityCardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-activity-card-header',
      // styles
      'w-full',
      'mb-5 flex items-start justify-between gap-2',
      className
    )}
    {...props}
  />
));
ActivityCardHeader.displayName = 'ActivityCardHeader';

const ActivityCardHeaderContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-activity-card-header-content',
      // styles
      'w-0 grow leading-snug',
      className
    )}
    {...props}
  />
));
ActivityCardHeaderContent.displayName = 'ActivityCardHeaderContent';

const ActivityCardTitle = React.forwardRef(({ className, size, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn(
      'c-activity-card-title',
      // styles
      'mb-0 text-base font-bold leading-snug text-primary',
      size === 'md' && 'text-xl',
      className
    )}
    {...props}
  />
));
ActivityCardTitle.displayName = 'ActivityCardTitle';

const ActivityCardSubtitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'c-activity-card-subtitle',
      // styles
      'mb-0 text-base font-bold leading-snug text-primary-dark',
      className
    )}
    {...props}
  />
));
ActivityCardSubtitle.displayName = 'ActivityCardSubtitle';

const ActivityCardInfo = React.forwardRef(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn(
      'c-activity-card-info',
      // styles
      'text-xs font-light text-primary-light',
      className
    )}
    {...props}
  />
));
ActivityCardInfo.displayName = 'ActivityCardInfo';

const ActivityCardBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-activity-card-body', className)}
    {...props}
  />
));
ActivityCardBody.displayName = 'ActivityCardBody';

const ActivityCardDescription = React.forwardRef(({ className, variant = 'default', ...props }, ref) => (
  <h2
    ref={ref}
    className={cn(
      'c-activity-card-description',
      // styles
      'text-sm font-light text-primary-dark',
      variant === 'default' && 'mb-9 border-b border-solid border-neutral-lightest pb-9',
      variant === 'plain' && '',
      className
    )}
    {...props}
  />
));
ActivityCardDescription.displayName = 'ActivityCardDescription';

export { ActivityCardHeader, ActivityCardHeaderContent, ActivityCardTitle, ActivityCardSubtitle, ActivityCardInfo, ActivityCardBody, ActivityCardDescription };
